import {useQuery} from 'react-query';
import getCultivations from '.';

const useGetCultivations = () => {
  const {data, isLoading} = useQuery(['cultivation-list'], getCultivations);
  return {cultivationList: data, isLoading};
};

export default useGetCultivations;
